import { styled, Theme, Typography } from "@material-ui/core";
import PodVideo from "../../../../../components/pod-video";

export const TitleTypography = styled(Typography)(
  ({ theme }: { theme: Theme; component: any }) => ({
    display: "inline",
    fontWeight: 400,
    fontSize: "5.0rem",
    lineHeight: "5.6rem",
    letterSpacing: "-1px",
    fontFamily: "Reckless",
    [theme.breakpoints.down("xs")]: {
      fontSize: "2.4rem",
      lineHeight: "3.0rem",
      letterSpacing: "0px"
    }
  })
);

export const BrandTypography = styled(Typography)(
  ({ theme }: { theme: Theme; component?: any }) => ({
    display: "inline",
    fontWeight: 400,
    fontSize: "2.4rem",
    lineHeight: "3.0rem",
    fontFamily: "Reckless",
    [theme.breakpoints.down("xs")]: {
      fontSize: "2.4rem",
      lineHeight: "3.6rem",
      letterSpacing: "0px"
    }
  })
);

export const PriceTypography = styled(Typography)(({ theme }) => ({
  display: "inline",
  fontWeight: 400,
  fontSize: "4rem",
  lineHeight: "3.2rem",
  fontFamily: "Reckless",
  [theme.breakpoints.down("xs")]: {
    fontSize: "3rem",
    lineHeight: "3.2rem"
  }
}));
